import { render, staticRenderFns } from "./ListarComarcas.vue?vue&type=template&id=4e7f9089&scoped=true"
import script from "./ListarComarcas.vue?vue&type=script&lang=js"
export * from "./ListarComarcas.vue?vue&type=script&lang=js"
import style0 from "./ListarComarcas.vue?vue&type=style&index=0&id=4e7f9089&prod&lang=css"
import style1 from "./ListarComarcas.vue?vue&type=style&index=1&id=4e7f9089&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7f9089",
  null
  
)

export default component.exports